import type {Trade} from '../tradeSchema';
import {calculateTradeProfitLoss} from './calculateTradeProfitLoss';

/**
 * Gross P/L from prices (see {@link calculateTradeProfitLoss}). Manual `profitLoss` (e.g. after
 * commission) should be no higher than that gross figure; when both exist, returns the smaller
 * value so inflated entries are capped.
 */
export function resolveTradeProfitLoss(trade: Trade): number | undefined {
  const calculatedProfitLoss = calculateTradeProfitLoss(
    trade.direction,
    trade.positionSize,
    trade.entryPrice,
    trade.exitPrice,
  );

  const storedProfitLoss = trade.profitLoss;
  if (storedProfitLoss === undefined || !Number.isFinite(storedProfitLoss) || storedProfitLoss === 0) {
    return calculatedProfitLoss;
  }

  // when there are some error in calculation such as negative price or position size
  if (calculatedProfitLoss === undefined) {
    return storedProfitLoss;
  }

  return Math.min(storedProfitLoss, calculatedProfitLoss);
}
